/**
 * An upload confirmation module - use whereever there's a document to be uploaded.
 */
import * as React from "react";
import { Button, FileUploaderItem } from "carbon-components-react";
import { TrashCan20 } from "@carbon/icons-react";

require("../assets/stylesheets/components/shared/uploads.scss");

interface UploadProps {
  deleteHandler: any;
  filename: any;
}

export default class UploadConfirmation extends React.Component<UploadProps, any> {
  constructor(props) {
    super(props);
  }

  render() {
    const MAX_FILENAME_LENGTH = 30;
    let { filename } = this.props;
    if (filename.length > MAX_FILENAME_LENGTH) {
      filename = `${filename.slice(0, MAX_FILENAME_LENGTH)}…`;
    }

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "300px",
          overflow: "visible",
          marginBottom: "5px",
        }}
      >
        <FileUploaderItem name={filename} status="complete" style={{ marginBottom: "0" }} />
        <Button
          onClick={this.props.deleteHandler}
          renderIcon={TrashCan20}
          hasIconOnly
          kind="danger--tertiary"
          iconDescription={`Delete document ${filename}`}
        />
      </div>
    );
  }
}
